// extracted by mini-css-extract-plugin
module.exports = {"search":"searchButton-module--search--fiEq-","searchIcon":"searchButton-module--search-icon--36E62"};